/**
 * Adapptio core library.
 *
 * @package core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum EDITOR_APP_PERMISSIONS {
	AppEditorImpersonate = "APP/IMPERSONATE",
	AppEditorRead = "APP/EDITOR_READ",
	AppEditorComment = "APP/EDITOR_COMMENT",
	AppEditorEdit = "APP/EDITOR_EDIT",
	AppIntegrationRead = "APP/INTEGRATION_READ",
	AppIntegrationManage = "APP/INTEGRATION_MANAGE",
	AppUsersRead = "APP/USERS_READ",
	AppUsersManage = "APP/USERS_MANAGE",
	AppRelease = "APP/RELEASE",
	AppDeployment = "APP/DEPLOYMENT",
	AppDeploymentProtected = "APP/DEPLOYMENT_PROTECTED"
}
